exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-signup{background:transparent}.card-signup{margin-top:10%;padding:20px!important}.logo{width:90px;height:auto;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/login/login.scss
// module id = 622
// module chunks = 0